import { createTheme } from '@mui/material/styles';

export function createPortfolioMuiTheme(isDark) {
  return createTheme({
    palette: {
      mode: isDark ? 'dark' : 'light',
      primary: { main: '#163300', light: '#9fe870', dark: '#054d28' },
      secondary: { main: '#378ADD' },
      background: {
        default: isDark ? '#0e0f0c' : '#fafbf8',
        paper: isDark ? '#161714' : '#ffffff',
      },
      text: {
        primary: isDark ? '#f4f4f0' : '#0e0f0c',
        secondary: isDark ? '#b8b9b4' : '#454745',
      },
      divider: isDark ? 'rgba(244,244,240,0.12)' : 'rgba(14,15,12,0.12)',
    },
    typography: {
      fontFamily: 'Inter, system-ui, sans-serif',
    },
    shape: { borderRadius: 12 },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'none',
          },
        },
      },
    },
  });
}

export function chartAxisSx(isDark) {
  return {
    width: '100%',
    maxWidth: '100%',
    '& svg': { maxWidth: '100%', display: 'block' },
    '& .MuiChartsAxis-line': {
      stroke: isDark ? 'rgba(148, 163, 184, 0.5)' : 'rgba(100, 116, 139, 0.45)',
    },
    '& .MuiChartsAxis-label': {
      fill: isDark ? '#b8b9b4' : '#454745',
      fontSize: 11,
    },
    '& .MuiChartsGrid-line': {
      stroke: isDark ? 'rgba(148, 163, 184, 0.12)' : 'rgba(100, 116, 139, 0.12)',
    },
    '& .MuiChartsAxis-tickLabel': {
      fill: isDark ? '#b8b9b4' : '#454745',
      fontSize: 11,
    },
  };
}

/** Borderless card — soft shadow + gradient fill */
export function mpdCardSx(theme) {
  const dark = theme.palette.mode === 'dark';
  return {
    p: 2,
    borderRadius: 3,
    border: 'none',
    minWidth: 0,
    overflow: 'hidden',
    boxShadow: dark
      ? '0 8px 32px rgba(0, 0, 0, 0.32), inset 0 1px 0 rgba(255, 255, 255, 0.05)'
      : '0 8px 28px rgba(14, 15, 12, 0.07), inset 0 1px 0 rgba(255, 255, 255, 0.9)',
    background: dark
      ? 'linear-gradient(168deg, rgba(28, 29, 26, 0.98) 0%, rgba(16, 17, 15, 1) 100%)'
      : 'linear-gradient(168deg, #ffffff 0%, #f4f8f1 100%)',
    transition: 'box-shadow 0.2s ease, transform 0.2s ease',
    '&:hover': {
      boxShadow: dark
        ? '0 12px 40px rgba(0, 0, 0, 0.38), inset 0 1px 0 rgba(255, 255, 255, 0.06)'
        : '0 12px 36px rgba(14, 15, 12, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.95)',
    },
  };
}

export const insightToneBg = {
  positive: 'rgba(74, 222, 128, 0.1)',
  neutral: 'rgba(56, 189, 248, 0.1)',
  caution: 'rgba(251, 191, 36, 0.12)',
};
